// extracted by mini-css-extract-plugin
export default {"pageWrap":"Xb-z","fullWidth":"Yb-z","heading":"Zb-z","fullBleed":"_b-z","hidden":"ac-z"};